import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading, authError, setAuthError, user, homePath } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Zaten giriş yapılmışsa yönlendir
  useEffect(() => {
    if (user) navigate(homePath(), { replace: true });
  }, [user, navigate, homePath]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAuthError('');
    try {
      const loggedUser = await login(email, password);
      // Rol bazlı yönlendirme
      const from = location.state?.from?.pathname;
      if (from && from !== '/login') {
        navigate(from, { replace: true });
      } else {
        navigate(loggedUser.role === 'super_admin' ? '/admin' : '/dashboard', { replace: true });
      }
    } catch {
      // hata AuthContext'te zaten set edildi
    }
  };

  return (
    <div style={s.page}>
      <div style={s.bg} />
      <div style={s.card}>
        {/* Logo */}
        <div style={s.logo}>
          <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
            <rect width="44" height="44" rx="14" fill="rgba(59,130,246,0.12)" />
            <path d="M10 32 L22 14 L34 32" stroke="#60a5fa" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="22" cy="14" r="3.5" fill="#3b82f6"/>
            <path d="M16 25 L28 25" stroke="#3b82f6" strokeWidth="1.5" strokeOpacity="0.5" strokeLinecap="round"/>
          </svg>
          <div>
            <div style={s.appName}>AVM Analitik</div>
            <div style={s.appSub}>Ziyaretçi Sayım Sistemi</div>
          </div>
        </div>

        <h2 style={s.title}>Giriş Yap</h2>
        <p style={s.subtitle}>Hesabınıza erişmek için bilgilerinizi girin</p>

        {/* Hata mesajı */}
        {authError && (
          <div style={s.errorBox} role="alert">
            <span>⚠</span> {authError}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="email">E-posta Adresi</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="ornek@sirket.com"
              required
              autoFocus
              autoComplete="username"
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Şifre</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '13px', marginTop: 8 }}
            disabled={loading || !email || !password}
          >
            {loading
              ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Giriş yapılıyor...</>
              : 'Giriş Yap'
            }
          </button>
        </form>

        <div style={s.footer}>
          <span>Promay Bilişim Teknolojileri</span>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    background: 'var(--bg)',
  },
  bg: {
    position: 'fixed', inset: 0, pointerEvents: 'none',
    background: 'radial-gradient(ellipse at 25% 25%, rgba(59,130,246,0.07) 0%, transparent 55%), radial-gradient(ellipse at 75% 75%, rgba(168,85,247,0.04) 0%, transparent 55%)',
  },
  card: {
    background: 'var(--surface)', border: '1px solid var(--border)',
    borderRadius: 'var(--r-lg)', padding: '40px',
    width: '100%', maxWidth: '420px',
    boxShadow: '0 8px 48px rgba(0,0,0,0.45)', position: 'relative', zIndex: 1,
  },
  logo: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32 },
  appName: { fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 18, color: 'var(--text)' },
  appSub: { fontSize: 11, color: 'var(--text3)', letterSpacing: '0.04em' },
  title: { fontSize: 24, marginBottom: 6 },
  subtitle: { color: 'var(--text2)', marginBottom: 24, fontSize: 14 },
  errorBox: {
    background: 'var(--red-dim)', border: '1px solid rgba(239,68,68,0.3)',
    color: 'var(--red)', padding: '10px 14px', borderRadius: 'var(--r-sm)',
    marginBottom: 16, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8,
  },
  footer: { textAlign: 'center', marginTop: 28, paddingTop: 20, borderTop: '1px solid var(--border)', fontSize: 12, color: 'var(--text3)' },
};
